import React from 'react';
import Format from '../../../../../Utils/formatCurrent';
import verificaSeParcelaAtrasada from '../../../../../Utils/checkIfBillIsLate';

import { CardContainer, InformacoesParcela, Top } from './styles';

import './styles.scss';

const CardParcelasSelecionadas = ({ parcela, tema }) => {
  const temaParcela = () => {
    if (
      verificaSeParcelaAtrasada(
        parcela?.parcela?.dtVencBoleto || parcela?.parcela?.dataVencimento
      )
    )
      return { bg: 'rgb(186,18,43,0.5)', color: 'rgb(186,18,43)' };
    else if (tema === '#0047BA')
      return { bg: 'rgb(0,71,186, 0.5)', color: 'rgb(0,71,186' };
    return { bg: 'rgb(29, 48, 84, 0.5)', color: 'rgb(29, 48, 84)' };
  };

  return (
    <CardContainer iconBG={temaParcela()} border={tema}>
      <InformacoesParcela>
        <Top tema={tema} iconBG={temaParcela()} size={'70%'} first>
          <div className='item'>
            <span>Tipo:</span>
            <span>{parcela?.parcela?.descricaoParcela}</span>
          </div>
          {
            <div className='item'>
              <span>Parcela:</span>
              <span>{parcela?.parcela?.numeroParcela}</span>
            </div>
          }
        </Top>
        <Top tema={tema} iconBG={temaParcela()} size={'50%'}>
          <div className='item'>
            <span>Vencimento:</span>
            <span>
              {(
                parcela?.parcela?.dtVencBoleto ||
                parcela?.parcela?.dataVencimento
              )

                ?.split('T')[0]
                ?.split('-')
                ?.reverse()
                ?.join('/')}
            </span>
          </div>
          <div className='item'>
            <span>Valor:</span>
            <span>
              {Format(
                parcela?.parcela?.grupoExpandido?.totalBoleto ??
                  parcela?.parcela?.valorReajustado
              )}
            </span>
          </div>
        </Top>
      </InformacoesParcela>
    </CardContainer>
  );
};

export default CardParcelasSelecionadas;
